import { generatePKCEPair } from '@provider/Login/util'
import localStore from '@service/local-store'

const pkceService = () => {
  const getChallenge = async () => {
    const { verifier, challenge } = await generatePKCEPair()
    localStore.set('auth-pair', { verifier, challenge })
    return challenge
  }

  const getVerifier = () => {
    const verifier = localStore.get('auth-pair').verifier || ''
    localStore.remove('auth-pair')
    return verifier
  }

  return {
    getVerifier,
    getChallenge,
  }
}

const pkce = pkceService()

export default pkce
